module.exports = __webpack_public_path__ + "staticcomp/img/cover.2265c23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/12/cover.jpg
// module id = OH42
// module chunks = 39